import { z } from "zod";

export const MemoryFactNodeContentSchema = z.object({
  nodeType: z.literal("memory"),
  version: z.literal("1"),
  content: z.string().max(2048),
});

export const MemoryFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("memory"),
  version: z.literal("1"),
});
